import styled from "styled-components";
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import { Link } from 'react-router-dom'



const InfoContainer = styled.div`
    opacity: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0; 
    left: 0;
    z-index: 3;
    background-color: rgba(0,0,0,0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: all 0.5s ease;
    cursor: pointer;
`

const Container = styled.div`
    flex: 1;
    margin: 10px;
    min-width: 280px;
    height: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #d3e4e6df;
    position: relative;
    border-radius: 4px;
    &:hover ${InfoContainer} {
        opacity: 1;
    }
`
const Circle = styled.div`
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: #d0e3e6d2;
    position: absolute;
`
const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 2;
`
const Icon = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px;
    transition: all 0.2s ease;
    &:hover{
        background-color: #bff7bfcc;
        transform: scale(1.2);
    }

`
const InfoCont = styled.div`
    display: flex;
    flex-direction: row;
`
const ServiceName = styled.h2`
    margin-top: 20px;
    font-weight: 400;
    color: white;
`
const LinkStyle = {
    color: "black",
    textDecoration: "none"
} 




const ServiceItem = ({item}) => {
    return (
        <Container >
            <Circle />
            <Image src={item.img} />
            <InfoContainer >
                <InfoCont >
                    <Link style={LinkStyle} to="cart">
                        <Icon >
                            <ShoppingCartOutlinedIcon />
                        </Icon>
                    </Link>
                    <Icon >
                        <SearchOutlinedIcon />
                    </Icon>
                    <Icon >
                        <FavoriteBorderOutlinedIcon />
                    </Icon>
                </InfoCont>
                <ServiceName > {item.title} </ServiceName>
            </InfoContainer>
        </Container>
    )
}

export default ServiceItem
